import { render, staticRenderFns } from "./Specifiche2.vue?vue&type=template&id=2d1e368e&scoped=true&"
import script from "./Specifiche2.vue?vue&type=script&lang=js&"
export * from "./Specifiche2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e368e",
  null
  
)

export default component.exports